import { useWallet } from '@solana/wallet-adapter-react'
import * as anchor from '@project-serum/anchor'
import { useAsyncRetry } from 'react-use'
import config from '../config/config'
import {
  getNftFromMetadata,
  getNftMetadatasForOwnerBatched,
  getNFTsForOwner,
  getNFTsForOwnerBatched,
} from './solUtils'
import { NftMetadata } from './nftmetaData.type'
import { Metadata } from '@metaplex/js'
import { fetchAllCoreNFTsByOwner } from './umiNFTUtils'
import { PublicKey } from '@solana/web3.js'

const rpcHost = config.rpcHost
const connection = new anchor.web3.Connection(rpcHost, { commitment: 'recent' })

// Enhanced types to support both legacy and core NFTs
export type NFTStandard = 'legacy' | 'core'

export type CoreNFT = {
  publicKey: string
  name: string
  uri: string
  owner: string
  standard: 'core'
}

export type LegacyNFT = {
  data: {
    data: {
      name: string
      symbol: string
      uri: string
    }
    mint: string
  }
  pubkey: PublicKey
  standard: 'legacy'
}

export type UnifiedNFTMetadata = (CoreNFT | LegacyNFT) & {
  standard: NFTStandard
}

const useWalletNfts = () => {
  const wallet = useWallet()

  const fetchNftsRes = useAsyncRetry(async () => {
    try {
      if (
        !wallet ||
        !wallet.publicKey ||
        !wallet.signAllTransactions ||
        !wallet.signTransaction
      ) {
        return null
      }

      /* const nftsForOwner = await getNFTsForOwnerV2({connection, ownerAddress: wallet.publicKey})

      const filtered = (nftsForOwner ?? []).filter(nft => !!nft.name).sort((a, b) => {
        if (!a.name.includes('#')) return 1
        if (!b.name.includes('#')) return -1
        return Number(a.name.split('#')[1]) - Number(b.name.split('#')[1])
      })

      return filtered */

      const nftsForOwner = await getNFTsForOwnerBatched({
        connection,
        ownerAddress: wallet.publicKey,
      })

      console.log('nftsForOwner', nftsForOwner.length)
      const nfts = nftsForOwner
        .filter((nft) => {
          /* if (!nft.name) console.error('fucked up nft', nft) */

          return !!nft.name
        })
        .sort((a, b) => {
          if (!a.name.includes('#')) return 1
          if (!b.name.includes('#')) return -1
          return Number(a.name.split('#')[1]) - Number(b.name.split('#')[1])
        })

      console.log('nfts', nfts)

      return nfts
    } catch (e) {
      console.error('e in useWalletNfts', e)
      await Promise.reject(e)
      return []
    }
  }, [wallet])

  return {
    loading: fetchNftsRes.loading,
    nfts: fetchNftsRes.value ?? [],
    refetch: fetchNftsRes.retry,
  }
}


// export const useWalletNftsMintInfo = (searchKey?: string) => {
//   const wallet = useWallet()

//   const fetchNftsRes = useAsyncRetry(async () => {
//     try {
//       if (
//         !wallet ||
//         !wallet.publicKey ||
//         !wallet.signAllTransactions ||
//         !wallet.signTransaction
//       ) {
//         return null
//       }

//       /* const nftsForOwner = await getNFTsForOwnerV2({connection, ownerAddress: wallet.publicKey})

//       const filtered = (nftsForOwner ?? []).filter(nft => !!nft.name).sort((a, b) => {
//         if (!a.name.includes('#')) return 1
//         if (!b.name.includes('#')) return -1
//         return Number(a.name.split('#')[1]) - Number(b.name.split('#')[1])
//       })

//       return filtered */

//       const mintInfosForOwner = await getNftMintInfosForOwnerBatched({
//         connection,
//         ownerAddress: wallet.publicKey,
//       })

//       console.log('mintInfosForOwner', mintInfosForOwner.length)
//       const mintInfos = mintInfosForOwner
//         .filter((mintInfo) => {
//           /* if (!nft.name) console.error('fucked up nft', nft) */

//           return (!!mintInfo.nftMetadataJson.name || !!mintInfo.nftMetadataJson.symbol) &&
//             searchKey
//             ? mintInfo.nftMetadataJson.name.includes(searchKey) || mintInfo.nftMetadataJson.symbol.includes(searchKey)
//             : true
//         })
//         .sort((a, b) => {
//           if (!a.nftMetadataJson.name.includes('#')) return 1
//           if (!b.nftMetadataJson.name.includes('#')) return -1
//           // First, compare the values before the '#' character
//           const aName = a.nftMetadataJson.name.split('#')[0]
//           const bName = b.nftMetadataJson.name.split('#')[0]
//           if (aName !== bName) {
//             return aName.localeCompare(bName)
//           }

//           // If the values before the '#' are the same, compare the numbers after the '#'
//           const aNum = parseInt(a.nftMetadataJson.name.split('#')[1], 10)
//           const bNum = parseInt(b.nftMetadataJson.name.split('#')[1], 10)
//           return aNum - bNum
//         })

//       console.log('mintInfos', mintInfos)

//       return mintInfos
//     } catch (e) {
//       console.error('e in useWalletMintInfos', e)
//       await Promise.reject(e)
//       return []
//     }
//   }, [wallet, searchKey])

//   return {
//     loading: fetchNftsRes.loading,
//     mintInfos: fetchNftsRes.value ?? [],
//     refetch: fetchNftsRes.retry,
//   }
// }

export const useWalletNftMetadatas = (shouldFetch?: boolean, searchKey?: string) => {
  const wallet = useWallet()

  const fetchNftsRes = useAsyncRetry(async () => {
    if (!shouldFetch) return []
    try {
      if (
        !wallet ||
        !wallet.publicKey ||
        !wallet.signAllTransactions ||
        !wallet.signTransaction
      ) {
        return null
      }

      /* const nftsForOwner = await getNFTsForOwnerV2({connection, ownerAddress: wallet.publicKey})

      const filtered = (nftsForOwner ?? []).filter(nft => !!nft.name).sort((a, b) => {
        if (!a.name.includes('#')) return 1
        if (!b.name.includes('#')) return -1
        return Number(a.name.split('#')[1]) - Number(b.name.split('#')[1])
      })

      return filtered */

      const metadatasForOwner = await getNftMetadatasForOwnerBatched({
        connection,
        ownerAddress: wallet.publicKey,
      })

      console.log('metadatasForOwner', metadatasForOwner.length)
      const metadatas = metadatasForOwner
        .filter((metadata) => {
          /* if (!nft.name) console.error('fucked up nft', nft) */

          return (!!metadata.data.data.name || !!metadata.data.data.symbol) &&
            searchKey
            ? metadata.data.data?.name?.includes(searchKey) || metadata.data.data?.symbol?.includes(searchKey)
            : true
        })
        .sort((a, b) => {
          if (!a.data.data.name.includes('#')) return 1
          if (!b.data.data.name.includes('#')) return -1
          // First, compare the values before the '#' character
          const aName = a.data.data.name.split('#')[0]
          const bName = b.data.data.name.split('#')[0]
          if (aName !== bName) {
            return aName.localeCompare(bName)
          }

          // If the values before the '#' are the same, compare the numbers after the '#'
          const aNum = parseInt(a.data.data.name.split('#')[1], 10)
          const bNum = parseInt(b.data.data.name.split('#')[1], 10)
          return aNum - bNum
        })

      console.log('metadatas', metadatas)

      return metadatas
    } catch (e) {
      console.error('e in useWalletNfts', e)
      await Promise.reject(e)
      return []
    }
  }, [wallet, searchKey])

  return {
    loading: fetchNftsRes.loading,
    metadatas: fetchNftsRes.value ?? [],
    refetch: fetchNftsRes.retry,
  }
}

// New function to fetch both legacy and core NFTs
export const useWalletUnifiedNftMetadatas = (shouldFetch?: boolean, searchKey?: string) => {
  const wallet = useWallet()

  const fetchNftsRes = useAsyncRetry(async () => {
    if (!shouldFetch) return []
    try {
      if (
        !wallet ||
        !wallet.publicKey ||
        !wallet.signAllTransactions ||
        !wallet.signTransaction
      ) {
        return null
      }

      // Fetch legacy NFTs
      const legacyMetadatas = await getNftMetadatasForOwnerBatched({
        connection,
        ownerAddress: wallet.publicKey,
      })

      // Transform legacy NFTs to unified format
      const unifiedLegacyNFTs: UnifiedNFTMetadata[] = legacyMetadatas
        .filter((metadata) => {
          return (!!metadata.data.data.name || !!metadata.data.data.symbol) &&
            searchKey
            ? metadata.data.data?.name?.toLowerCase().includes(searchKey.toLowerCase()) || metadata.data.data?.symbol?.toLowerCase().includes(searchKey.toLowerCase())
            : true
        })
        .map((metadata) => ({
          ...metadata,
          standard: 'legacy' as const,
        }))

      // Fetch core NFTs
      const coreNFTs = await fetchAllCoreNFTsByOwner(wallet.publicKey.toBase58())

      // Transform core NFTs to unified format
      const unifiedCoreNFTs: UnifiedNFTMetadata[] = coreNFTs
        .filter((coreNft) => {
          return !!coreNft.name &&
            searchKey
            ? coreNft.name.toLowerCase().includes(searchKey.toLowerCase())
            : true
        })
        .map((coreNft) => ({
          publicKey: coreNft.publicKey,
          name: coreNft.name,
          uri: coreNft.uri,
          owner: coreNft.owner,
          standard: 'core' as const,
        }))

      // Combine and sort
      const allNFTs = [...unifiedLegacyNFTs, ...unifiedCoreNFTs]
        .sort((a, b) => {
          const aName = a.standard === 'legacy' ? a.data.data.name : a.name
          const bName = b.standard === 'legacy' ? b.data.data.name : b.name

          if (!aName.includes('#')) return 1
          if (!bName.includes('#')) return -1
          
          // First, compare the values before the '#' character
          const aBaseName = aName.split('#')[0]
          const bBaseName = bName.split('#')[0]
          if (aBaseName !== bBaseName) {
            return aBaseName.localeCompare(bBaseName)
          }

          // If the values before the '#' are the same, compare the numbers after the '#'
          const aNum = parseInt(aName.split('#')[1], 10)
          const bNum = parseInt(bName.split('#')[1], 10)
          return aNum - bNum
        })

      console.log('unified NFTs', {
        legacy: unifiedLegacyNFTs.length,
        core: unifiedCoreNFTs.length,
        total: allNFTs.length
      })

      return allNFTs
    } catch (e) {
      console.error('e in useWalletUnifiedNftMetadatas', e)
      await Promise.reject(e)
      return []
    }
  }, [wallet, searchKey])

  return {
    loading: fetchNftsRes.loading,
    unifiedMetadatas: fetchNftsRes.value ?? [],
    refetch: fetchNftsRes.retry,
  }
}

// Helper function to get NFT display data from unified metadata
export const getNFTDisplayData = (unifiedNFT: UnifiedNFTMetadata) => {
  if (unifiedNFT.standard === 'legacy') {
    return {
      name: unifiedNFT.data.data.name,
      symbol: unifiedNFT.data.data.symbol || '',
      pubkey: unifiedNFT.pubkey,
      mint: unifiedNFT.data.mint,
    }
  } else {
    return {
      name: unifiedNFT.name,
      symbol: '',
      pubkey: new PublicKey(unifiedNFT.publicKey),
      mint: unifiedNFT.publicKey,
    }
  }
}

// Helper function to convert unified NFT to SelectedNFTType
export const convertToSelectedNFTType = (unifiedNFT: UnifiedNFTMetadata, image?: string) => {
  const displayData = getNFTDisplayData(unifiedNFT)
  return {
    pubkey: displayData.pubkey,
    name: displayData.name,
    image,
    isCoreNFT: unifiedNFT.standard === 'core',
  }
}

export const useNftFromMetadata = (metadata: Metadata, stopLoading?: boolean) => {
  const fetchNftResult = useAsyncRetry(async () => {
    if (stopLoading) return null
    return getNftFromMetadata(metadata)
  }, [metadata, stopLoading])
  return {
    loading: fetchNftResult.loading,
    nft: fetchNftResult.value,
    refetch: fetchNftResult.retry,
  }
}

// New hook for unified NFT data fetching
export const useNftFromUnifiedMetadata = (unifiedMetadata: UnifiedNFTMetadata, stopLoading?: boolean) => {
  const fetchNftResult = useAsyncRetry(async () => {
    if (stopLoading) return null
    
    if (unifiedMetadata.standard === 'core') {
      // For core NFTs, we can fetch metadata from URI
      try {
        const response = await fetch(unifiedMetadata.uri)
        const metadata = await response.json()
        return {
          ...convertToSelectedNFTType(unifiedMetadata),
          image: metadata.image,
          description: metadata.description,
          attributes: metadata.attributes,
        }
      } catch (e) {
        console.error('Failed to fetch core NFT metadata:', e)
        return convertToSelectedNFTType(unifiedMetadata)
      }
    } else {
      // For legacy NFTs, use existing function
      return getNftFromMetadata(unifiedMetadata)
    }
  }, [unifiedMetadata, stopLoading])
  
  return {
    loading: fetchNftResult.loading,
    nft: fetchNftResult.value,
    refetch: fetchNftResult.retry,
  }
}

export type WalletNftV2 = ReturnType<typeof useWalletNfts>['nfts'][0]

export type WalletNftMetadataV2 = ReturnType<
  typeof useWalletNftMetadatas
>['metadatas'][0]

export type WalletUnifiedNftMetadataV2 = ReturnType<
  typeof useWalletUnifiedNftMetadatas
>['unifiedMetadatas'][0]

export default useWalletNfts
